export default "__VITE_ASSET__CAdk9kFR__"